import { render } from "./privacyProtocol.vue?vue&type=template&id=229edd50"
const script = {}

import "./privacyProtocol.vue?vue&type=style&index=0&id=229edd50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__